export const DevicesReportPage = () => <main />;
